import React, { FC, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import cls from './FileInput.module.css';
import { OldFilesItem } from './OldFilesItem';

export const FileInput = ({
    title,
    isRequired,
    value,
    onChange,
    name,
    fileText,
    isDisabled = false,
    error = null,
    oldFiles = [],
    oldFilesHandler = () => {},
}) => {
    const ref = useRef();

    useEffect(() => {
        const inputTextNew = value.map((image) => image.name).join(', ');
        setInputText(inputTextNew);
    }, [value]);

    const [inputText, setInputText] = useState('');

    return (
        <div className={classNames(cls.formBlockContent, { [cls.disabled]: isDisabled })}>
            {title && (
                <label className={classNames(cls.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}

            <div className={classNames(cls.fieldFileWrapper)}>
                <input
                    disabled={isDisabled}
                    onChange={onChange}
                    name="file"
                    type="file"
                    id="field__file-2"
                    className={classNames(cls.fieldFile)}
                    multiple
                    ref={ref}
                />

                <label className={classNames(cls.fieldFileWrapper)} htmlFor="field__file-2">
                    <div className={classNames(cls.fieldFileFake)}>
                        <span className={classNames(cls.ellipsisText)}>
                            {inputText || i18next.t('FileInput.return.inputText')}
                        </span>
                    </div>
                    <div className={classNames(cls.fieldFileButton)}>
                        {i18next.t('FileInput.return.fieldFileButton.select')}
                    </div>
                </label>
            </div>
            {error ? (
                <span className={classNames(cls.errorMessage)}>{error}</span>
            ) : (
                <span className={classNames(cls.formatMessage)}>
                    {i18next.t('FileInput.return.formatMessage')}: doc, pdf, csv, xls, txt, jpg, png
                </span>
            )}
            {!!oldFiles.length && (
                <div className={classNames(cls.oldFilesWrapper)}>
                    {oldFiles.map((file) => (
                        <OldFilesItem
                            isDisabled={isDisabled}
                            oldFilesHandler={oldFilesHandler}
                            key={file.id}
                            file={file}
                        />
                    ))}
                </div>
            )}
            {/* {error && <span className={classNames(cls.errorMessage)}>{error}</span>} */}
        </div>
    );
};
